import React, { FC } from 'react';

import { NewsItem } from '@domains/news';

import { ArticleCard } from '@components/article/ArticleCard/ArticleCard';

import styles from './NewsGrid.module.scss';

export type NewsGridProps = {
    news: NewsItem[];
};

export const NewsGrid: FC<NewsGridProps> = (props) => {
    const { news } = props;

    return (
        <div className={styles.root}>
            {news.map((item) => (
                <ArticleCard
                    key={item.slug}
                    slug={item.slug}
                    type={item.type}
                    thumbnail={item.thumbnail}
                    title={item.title}
                    dates={item.dates}
                />
            ))}
        </div>
    );
};
